<!-- Hero Offer Full Width -->
@if (slice.offer_display === 'Full width') {
  @if (brand.isYallo()) {
    <lib-curved-box curve="bottom" [backgroundImage]="slice.offer?.images.original.url" class="relative grid">
      <ng-container *ngTemplateOutlet="offerFullWidth; context: { slice }"></ng-container>
    </lib-curved-box>
  } @else {
    <div
      class="relative grid text-white pb-8 bg-lebara"
      [style.backgroundImage]="
        slice.offer?.images.original.url ? 'url(' + slice.offer?.images.original.url + ')' : undefined
      "
      [ngClass]="{ 'centered-image': slice.offer?.images.original.url }"
    >
      <ng-container *ngTemplateOutlet="offerFullWidth; context: { slice }"></ng-container>
    </div>
  }
  <ng-template #offerFullWidth>
    <div class="container py-6">
      <div class="relative mx-4 pt-20 lg:pt-0">
        <div class="flex flex-col items-center">
          @if (slice.title) {
            <div data-source="prismic" class="text-white mb-1.5 text-center" [innerHtml]="slice.title"></div>
          }
          @if (slice.description) {
            <div data-source="prismic" class="text-white text-center font-normal" [innerHtml]="slice.description"></div>
          }
          @if (slice.button_text) {
            <lib-link [link]="slice.button_link" class="my-4">
              <div class="button">
                <div class="flex items-center justify-center text-lg">
                  @if (slice.button_icon) {
                    <lib-svg class="text-white normal-plus mr-2" [svg]="slice.button_icon"> </lib-svg>
                  }
                  {{ slice.button_text }}
                </div>
              </div>
            </lib-link>
          }
          <ngx-dynamic-hooks
            data-source="prismic"
            class="offer-box"
            [content]="slice.offer?.content"
            [options]="{ sanitize: false }"
          >
          </ngx-dynamic-hooks>
        </div>
        @for (slice of slice.offer?.slices; track slice) {
          <div class="flex justify-center">
            @if (slice.type === 'count_down') {
              <lib-countdown [countdownDateFromPrismic]="$any(slice).countdownDate"> </lib-countdown>
            }
            @if (slice.type === 'offer_cta') {
              <lib-offer-box-button [slice]="$any(slice)" class="w-full lg:w-2/4"> </lib-offer-box-button>
            }
            <!-- Disableing banner as it looks ugly on full width hero offer because of the new requested banner style -->
            <!-- <lib-offer-sticker *ngIf="slice.type === 'squircle'" [slice]="$any(slice)">
          </lib-offer-sticker> -->
          </div>
        }
      </div>
    </div>
  </ng-template>
} @else {
  @if (brand.isYallo()) {
    <lib-curved-box
      [height]="slice.offer && !slice.secondaryOffer ? 75 : 100"
      [curve]="slice.secondaryOffer ? 'none' : 'bottom'"
      [backgroundImage]="slice.background_url ? slice.background_url : undefined"
      class="relative grid"
    >
      <ng-container *ngTemplateOutlet="offerBox; context: { slice }"></ng-container>
    </lib-curved-box>
  } @else {
    <div
      class="relative grid bg-lebara pb-8"
      [ngClass]="{ 'partial-hero': slice.offer, 'centered-image': slice.background_url && !slice.offer }"
      [style.backgroundImage]="slice.background_url ? 'url(' + slice.background_url + ')' : undefined"
    >
      <ng-container *ngTemplateOutlet="offerBox; context: { slice }"></ng-container>
    </div>
  }
}

<!-- Hero Offer Box -->

<ng-template #offerBox>
  <div class="flex flex-col items-center py-6 px-4">
    @if (slice.title) {
      <ngx-dynamic-hooks
        data-source="prismic"
        class="text-white mb-1.5 text-center"
        [content]="slice.title"
        [options]="{ sanitize: false }"
      >
      </ngx-dynamic-hooks>
    }
    @if (slice.description) {
      <ngx-dynamic-hooks
        data-source="prismic"
        class="text-white text-center font-normal"
        [content]="slice.description"
        [options]="{ sanitize: false }"
      >
      </ngx-dynamic-hooks>
    }
    @if (slice.button_text) {
      <lib-link [link]="slice.button_link" class="my-4">
        <div class="button" (click)="onButtonClick()">
          <div class="flex items-center justify-center text-lg">
            @if (slice.button_icon) {
              <lib-svg class="text-white normal-plus mr-2" [svg]="slice.button_icon"> </lib-svg>
            }
            {{ slice.button_text }}
          </div>
        </div>
      </lib-link>
    }
    @if (slice.image) {
      <img [src]="slice.image" [alt]="slice.image_alt" />
    }
  </div>
  @if (slice.offer) {
    <div class="h-full">
      @if (!slice.secondaryOffer) {
        <div class="container">
          <div class="mx-4 lg:mx-5">
            <lib-offer-box
              [offer]="slice.offer"
              [lazyLoadImage]="!slice.isHeadSlice"
              class="w-full offer-box"
              [isHeroOffer]="true"
              (offerClick)="onOfferClick($event)"
            >
            </lib-offer-box>
          </div>
        </div>
      } @else {
        <div class="lg:container md:flex justify-between h-full">
          <lib-offer-box-light
            [offer]="slice.offer"
            [lazyLoadImage]="!slice.isHeadSlice"
            class="offer-box h-full"
            [isHeroOffer]="true"
            [styleSide]="'left'"
          >
          </lib-offer-box-light>
          <lib-offer-box-light
            [offer]="slice.secondaryOffer"
            [lazyLoadImage]="!slice.isHeadSlice"
            class="offer-box h-full"
            [isHeroOffer]="true"
            [styleSide]="'right'"
          >
          </lib-offer-box-light>
        </div>
      }
    </div>
  }
</ng-template>
